import { asyncActionCreator } from '../../global/redux';
import * as constants from './constants';

export const postInstagramCodeAction = asyncActionCreator(constants.POST_INSTAGRAM_CODE);

export const postInstagramUserTokenAction = asyncActionCreator(constants.POST_INSTAGRAM_USER_TOKEN);
